import { Box, LinearProgress, linearProgressClasses, styled, Typography, useTheme } from '@mui/material';
// import { ColumnDef } from '@tanstack/react-table';
import Button from 'components/Common/Button';
// import DataTable from 'components/Common/Datatable';
// import Input from 'components/Common/Input';
// import { useForm } from 'react-hook-form';
import {
  useGetBillingStats
  // useGetCancelSubscription,
  // useGetTransactions
} from 'apis/business/setting/billing/hook';
import Spinner from 'components/Common/Spinner';
// import { TransactionResponse } from 'apis/business/setting/billing/types';
// import { formatDate } from 'utils/helperFunctions';

export default function Billing() {
  const theme = useTheme();

  // const { handleSubmit, control } = useForm();

  // const { data: transactions, isLoading } = useGetTransactions();
  // const { data: cancelSubscription } = useGetCancelSubscription();
  const { data: billingStats, isLoading: isBillingStatsLoading } = useGetBillingStats();

  // const onSubmit = (record: any) => {
  //   console.log(record);
  // };

  // const handleCancelSubscription = () => {
  //   window.location.href = cancelSubscription?.manage_url || '';
  // };

  if (isBillingStatsLoading) {
    return <Spinner />;
  }
  return (
    <>
      <Typography variant='h6' marginBottom='24px'>
        Billing
      </Typography>
      <Box bgcolor={theme.palette.background.paper} sx={{ borderRadius: '8px', padding: '32px 24px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Typography fontWeight='600'>Zappy Health</Typography>
            <Button variant='contained' sx={{ backgroundColor: 'primary.light', color: 'primary.main' }}>
              Business
            </Button>
            <Typography color='secondary'>(active)</Typography>
          </Box>
          <Typography color='secondary'>Usage reset:Oct 08/2024</Typography>
        </Box>

        <Box marginTop='26px' sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography color='secondary' variant='body2'>
            Available minutes
          </Typography>
          <Typography variant='body2'>{billingStats?.remaining_subscription_minutes}/43800</Typography>
        </Box>
        <BorderLinearProgress
          variant='determinate'
          value={(billingStats?.remaining_subscription_minutes ?? 1 / 43800) * 100}
        />

        <Box marginTop='26px' sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography color='secondary' variant='body2'>
            Team members
          </Typography>
          <Typography variant='body2'>{billingStats?.total_team_members}/∞</Typography>
        </Box>
        <BorderLinearProgress variant='determinate' value={billingStats?.total_team_members} />

        <Box marginTop='26px' sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography color='secondary' variant='body2'>
            Agents
          </Typography>
          <Typography variant='body2'>{billingStats?.total_agents}/∞</Typography>
        </Box>
        <BorderLinearProgress variant='determinate' value={billingStats?.total_agents} />

        {/* <Typography fontWeight='500' marginTop='26px'>
          Add more minutes
        </Typography>
        <Typography marginY='16px' color='secondary'>
          Every "re-charge" comes with 100 minutes each (ex: entering 1 in the quantity field below will
          recharge your account with 100 minutes). How many of them would you like to add to your account
          balance today ?
        </Typography>

        <Box
          component='form'
          onSubmit={handleSubmit(onSubmit)}
          mt={2}
          sx={{ display: 'flex', gap: '24px', alignItems: 'center' }}
        >
          <Input name='Quantity' label='Quantity' control={control} />
          <Button type='submit' variant='contained'>
            Add to my balance
          </Button>
        </Box>

        <Box sx={{ paddingY: '24px', borderBottom: '1px solid #F3F3F3' }}>
          <Typography color='secondary' sx={{ display: 'inline' }}>
            Have questions about your plan?
          </Typography>
          <Typography
            sx={{
              display: 'inline',
              marginLeft: '8px'
            }}
          >
            Compare plans
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginY: '26px'
          }}
        >
          <Typography>Payment account *** 3262</Typography>
          <Box sx={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
            <Button
              variant='contained'
              onClick={() => handleCancelSubscription()}
              sx={{
                border: '1px solid #F3F3F3',
                backgroundColor: 'white',
                color: '#777777'
              }}
            >
              Cancel Subscription
            </Button>
            <Button variant='contained'>Update Now</Button>
          </Box>
        </Box>

        <DataTable data={transactions?.data} columns={columns} isHeaderSticky={true} isLoading={isLoading} /> */}
      </Box>
    </>
  );
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800]
    })
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: 'primary',
    ...theme.applyStyles('dark', {
      backgroundColor: '#308fe8'
    })
  }
}));

// const columns: ColumnDef<TransactionResponse>[] = [
//   {
//     header: 'Status',
//     cell: ({ row }) => (
//       <Box display='flex' gap={1}>
//         {row.original.status === 'succeeded' ? <SuccessIcon/> : <FailedIcon/>}
//         {row.original.status}
//       </Box>
//     )
//   },
//   {
//     header: 'Date',
//     accessorKey: 'created',
//     cell: (info) => (
//       <Box display='flex' gap={1}>
//         {formatDate((info.getValue() as number) * 1000, 'yyyy-MM-dd')}
//       </Box>
//     )
//   },
//   {
//     header: 'Amount',
//     accessorKey: 'amount'
//   },
//   {
//     header: 'Payment',
//     cell: ({ row }) => row.original?.payment_method_details?.card?.brand
//   },
//   {
//     header: 'Detail',
//     accessorKey: 'receipt_url',
//     cell: ({ row }) => (
//       <a href={row.original.receipt_url} target='_blank' rel='noopener noreferrer'>
//         <Button variant='contained' sx={{ backgroundColor: 'primary.light', color: 'primary.main' }}>
//           Invoice
//         </Button>
//       </a>
//     )
//   }
// ];
